var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_526",
    "data-name": "Group 526",
    transform: "translate(14701)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    "data-name": "Rectangle 225",
    width: 24,
    height: 24,
    transform: "translate(-14701)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check_box_FILL0_wght300_GRAD0_opsz24",
    d: "M148.354-805.465l7.909-7.91-1.24-1.24-6.67,6.67L145-811.3l-1.24,1.24ZM142.128-800a2.053,2.053,0,0,1-1.509-.618,2.053,2.053,0,0,1-.618-1.509v-15.747a2.053,2.053,0,0,1,.618-1.509,2.053,2.053,0,0,1,1.509-.618h15.747a2.053,2.053,0,0,1,1.509.618,2.053,2.053,0,0,1,.618,1.509v15.747a2.053,2.053,0,0,1-.618,1.509,2.053,2.053,0,0,1-1.509.618Zm0-1.765h15.747a.346.346,0,0,0,.249-.113.346.346,0,0,0,.113-.249v-15.747a.346.346,0,0,0-.113-.249.346.346,0,0,0-.249-.113H142.128a.346.346,0,0,0-.249.113.346.346,0,0,0-.113.249v15.747a.346.346,0,0,0,.113.249A.346.346,0,0,0,142.128-801.764Zm-.362-16.471v0Z",
    transform: "translate(-14839.001 821.999)",
    fill: "#15345a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.ec74987063c6c2b020a6142b13a5ae2b.svg";
export { ForwardRef as ReactComponent };